import { NotifyWpFeedbackUser } from 'types/api/task';
import { cn } from 'utils/cn';
import { Avatar } from '../Avatar';

type AvatarStackProps = {
  users: NotifyWpFeedbackUser[];
  maxVisible?: number;
};

export const AvatarStack = ({
  users = [],
  maxVisible = 3,
}: AvatarStackProps) => {
  const visibleUsers = [...users] // Create a shallow copy of the users array
    .sort((a, b) => {
      // Sort responsible users first
      if (a.responsible && !b.responsible) return -1;
      if (!a.responsible && b.responsible) return 1;
      return 0;
    })
    .filter((u) => u.checked)
    .slice(0, maxVisible);
  const remainingCount = Math.max(
    0,
    users.filter((u) => u.checked).length - maxVisible
  );
  const pixelOffset = 16;

  return (
    <div className="flex  min-w-5 items-center border border-input rounded-lg bg-white p-0.5 overflow-hidden dark:bg-card dark:border-border">

      {visibleUsers.map((user, index) => (
        <div key={user.value} className='flex -space-x-4'>
          <Avatar
            src={user.avatar}
            alt={user.name}
            id={user.value}
            email={user.email}
            size="fit"
            className={cn(
              'ring-2 ring-background grow h-5 w-5 text-[10px]',
              user.responsible ? 'at-ch-responsible' : '',
              'hover:z-30 focus:z-30'
            )}

            title={user.label}
          />

        </div>
      ))}
      {remainingCount > 0 && (
        <div className='flex -space-x-4 ring-2 ring-background rounded-[4px] overflow-hidden bg-white text-secondary hover:z-30 focus:z-30'>
          <Avatar
            size="fit"
            placeholder={`+${remainingCount}`}
            className='text-[10px] leading-none h-5 w-5 text-textcolor grow'
          />
        </div>
      )}
    </div>
  );
};
